import React, { useEffect, useMemo } from "react";
import {
  PageLayout,
  PageLayoutConfig,
} from "@/components/layout/index";
import { usePageConfig } from "@/hooks/usePageConfig";
import { useOutletContext } from "react-router-dom";
import { usePageAccessGuard } from '@/hooks/usePageAccessGuard';

export default function TMSPage() {
  usePageAccessGuard('tms');
  const { isEditMode, setIsEditMode } = useOutletContext<{ isEditMode: boolean; setIsEditMode: (mode: boolean) => void }>();
  
  const defaultConfig: PageLayoutConfig = useMemo(() => ({
    title: "Localization",
    spacing: 0,
    padding: 0,
    rows: [],
  }), []);

  const {
    pageLayoutConfig,
    isLoading,
    handlePageConfigChange,
    reloadConfig,
    LoadingComponent,
    NoConfigComponent,
  } = usePageConfig({
    sectionKey: 'tms_page',
    defaultConfig,
    title: 'Localization',
    loadingMessage: 'Loading localization...',
    noConfigMessage: 'No localization configuration available',
  });

  // Listen for events from AppLayout
  useEffect(() => {
    const handleSaveChanges = () => {
      if (pageLayoutConfig) {
        handlePageConfigChange(pageLayoutConfig);
      }
    };

    const handleCancelChanges = () => {
      // Reload the original config from the store
      reloadConfig();
    };

    window.addEventListener('saveChanges', handleSaveChanges);
    window.addEventListener('cancelChanges', handleCancelChanges);

    return () => {
      window.removeEventListener('saveChanges', handleSaveChanges);
      window.removeEventListener('cancelChanges', handleCancelChanges);
    };
  }, [pageLayoutConfig, handlePageConfigChange, reloadConfig]);

  if (isLoading) {
    return <LoadingComponent />;
  }

  if (!pageLayoutConfig) {
    return <NoConfigComponent />;
  }

  return (
    <div className="h-full flex flex-col">
      <PageLayout
        config={pageLayoutConfig}
        onConfigChange={handlePageConfigChange}
        editMode={isEditMode}
        onEditModeChange={setIsEditMode}
        showTitle={false}
      />
    </div>
  );
}
